




















































































import Vue, { VueConstructor } from 'vue';
import {
	email, required, alphaNum, or,
} from 'vuelidate/lib/validators';
import { mapGetters, mapState, mapMutations } from 'vuex';
import FormError from '@/components/ui/FormError.vue';
import FormInput from '@/components/ui/FormInput.vue';
import FormPasswordInput from '@/components/ui/FormPasswordInput.vue';
import Customer from '@/models/Customer';

interface SignInRequest {
	location: string;
	login: string;
	password: string;
}

interface VuexBindings {
	isLoading: boolean;
	location: Locations.Location;
	paths: App.Paths;
}

const emailOrAlphaNum = or(email, alphaNum);

export default (Vue as VueConstructor<Vue & VuexBindings>).extend({
	name: 'LoginForm',

	components: {
		FormError,
		FormInput,
		FormPasswordInput,
	},

	props: {
		buttonText: { type: String, default: 'Login' },
		classes: {},
		forgotText: { type: String, default: 'Forgot Password?' },
		activateText: { type: String, default: 'Activate Account' },
		idPrefix: String,
		hasMarketing: { type: Boolean, default: false },
		loginGreeting: { type: String, default: 'Welcome [FirstName] [LastName]!' },
		noLoginGreeting: { type: String, default: 'Welcome! [Login /] or [Register /]' },
		redirect: { type: String, default: 'profile' },
		registerText: { type: String, default: 'Sign Up' },
		title: { type: String, default: 'login-only' },
		value: Object as () => { login: string; password: string; location: string},
	},

	data() {
		return {
			email: '' as string,
			localErrors: {} as any,
			password: '' as string,
		};
	},

	computed: {
		...mapState(['isLoading', 'paths']),
		...mapGetters('location', ['location']),

		model(): SignInRequest {
			return {
				location: (this.location as Locations.Location).codeID || '',
				login: this.email,
				password: this.password,
			};
		},
	},

	methods: {
		...mapMutations(['setLoggedIn', 'setLoading']),

		async submit() {
			this.$v.$touch();
			this.localErrors = {};

			if (this.$v.$invalid) {
				return;
			}

			this.$store.dispatch('googleEvents/loginAttempt', {
				email: this.model.login,
				location: this.model.location,
			});

			try {
				this.setLoading(true);
				const result = await Customer.login(this.model.login, this.model.password, this.model.location);
				if (result.needs_activated) {
					this.$emit('activate');
					this.setLoading(false);
				} else {
					this.setLoggedIn(new Customer(result));
					this.setLoading(false);
					this.$emit('login', result);
				}
			} catch (error) {
				this.setLoading(false);

				error.errors.forEach((e: any) => {
					if (e.name) {
						this.$set(this.localErrors, e.name, e.text);
					} else {
						this.$set(this.localErrors, 'page', e.text);
					}
				});
			}

			// if (this.redirect !== 'profile') {
			// 	this.password = '';
			// 	(this.$v as any).password.$reset();
			// }
		},

		toggleForgetPassword() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'forgotPassword',
				fromInfo: '',
			});
			this.$emit('forget-password');
		},
	},

	validations: {
		email: {
			emailOrAlphaNum,
			required,
		},
		password: {
			required,
		},
	},
});
